<template>
  <div class="edit-page-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <form
              @submit.prevent="handleFormSubmit">

            <div class="row title-row">
              <div class="col-12">
                <h2>Transiting</h2>
              </div>

              <div class="col-4">
                <label for="transiting_planet">
                  <select
                      name="transiting_planet"
                      id="transiting_planet"
                      :disabled="isProgressedDataChecked || isHouseEntryChecked || isTransitingHouseEntryChecked || editMode"
                      v-model="transitionData.transitingPlanetValue"
                      :required="isTransitionDataChecked"
                  >
                    <option value="" disabled selected hidden>Transiting Planet</option>
                    <option
                        v-for="(single_transiting_planet, index) in ['', ...transiting.transiting_planet]"
                        :key="index"
                        :value="single_transiting_planet"
                    >{{ single_transiting_planet }}
                    </option>
                  </select>
                </label>
              </div>

              <div class="col-4">
                <label for="transiting_aspect">
                  <select
                      name="transiting_aspect"
                      id="transiting_aspect"
                      :disabled="isProgressedDataChecked || isHouseEntryChecked || isTransitingHouseEntryChecked || editMode"
                      v-model="transitionData.aspectValue"
                      :required="isTransitionDataChecked"
                  >
                    <option value="" disabled selected hidden>Aspect</option>
                    <option
                        v-for="(single_aspect, index) in ['', ...transiting.aspect]"
                        :key="index"
                        :value="single_aspect"
                    >{{ single_aspect }}
                    </option>
                  </select>
                </label>
              </div>

              <div class="col-4">
                <label for="transiting_natal_planet">
                  <select
                      name="transiting_natal_planet"
                      id="transiting_natal_planet"
                      :disabled="isProgressedDataChecked || isHouseEntryChecked || isTransitingHouseEntryChecked || editMode"
                      v-model="transitionData.natalPlanetValue"
                      :required="isTransitionDataChecked"
                  >
                    <option value="" disabled selected hidden>Natal Planet</option>
                    <option
                        v-for="(single_natal_planet, index) of  ['', ...transiting.natal_planet]"
                        :key="index"
                        :value="single_natal_planet"
                    >{{ single_natal_planet }}
                    </option>
                  </select>
                </label>
              </div>
            </div>

            <div class="row title-row">
              <div class="col-12">
                <h2>Progressed</h2>
              </div>
              <div class="col-4">
                <label for="progressed_planet">
                  <select
                      name="progressed_planet"
                      id="progressed_planet"
                      :disabled="isTransitionDataChecked || isHouseEntryChecked || isTransitingHouseEntryChecked || editMode"
                      v-model="progressedData.progressedPlanetValue"
                      :required="isProgressedDataChecked"
                  >
                    <option value="" disabled selected hidden>Progressed Planet</option>
                    <option
                        v-for="(singleProgressedPlanet, index) of ['', ...progressed.progressed_planet]"
                        :key="index"
                        :value="singleProgressedPlanet"
                    >{{ singleProgressedPlanet }}
                    </option>
                  </select>
                </label>
              </div>

              <div class="col-4">
                <label for="progressed_aspect">
                  <select
                      name="progressed_aspect"
                      id="progressed_aspect"
                      :disabled="isTransitionDataChecked || isHouseEntryChecked || isTransitingHouseEntryChecked || editMode"
                      v-model="progressedData.aspectValue"
                      :required="isProgressedDataChecked"
                  >
                    <option value="" disabled selected hidden>Aspect</option>
                    <option
                        v-for="(single_aspect, index) in ['', ...progressed.aspect]"
                        :key="index"
                        :value="single_aspect"
                    >{{ single_aspect }}
                    </option>
                  </select>
                </label>
              </div>

              <div class="col-4">
                <label for="progressed_natal_planet">
                  <select
                      name="progressed_natal_planet"
                      id="progressed_natal_planet"
                      :disabled="isTransitionDataChecked || isHouseEntryChecked || isTransitingHouseEntryChecked || editMode"
                      v-model="progressedData.natalPlanetValue"
                      :required="isProgressedDataChecked"
                  >
                    <option value="" disabled selected hidden>Natal Planet</option>
                    <option
                        v-for="(single_natal_planet, index) of  ['', ...progressed.natal_planet]"
                        :key="index"
                        :value="single_natal_planet"
                    >{{ single_natal_planet }}
                    </option>
                  </select>
                </label>
              </div>
            </div>

            <div class="row title-row">
              <div class="col-12">
                <h2>Transiting House Entry</h2>
              </div>
              <div class="col-4">
                <label for="transiting_progressed_planet">
                  <select
                      name="transiting_progressed_planet"
                      id="transiting_progressed_planet"
                      :disabled="isTransitionDataChecked || isHouseEntryChecked || isProgressedDataChecked || editMode"
                      v-model="transitingHouseEntryData.transitingPlanetValue"
                      :required="isTransitingHouseEntryChecked"
                  >
                    <option value="" disabled selected hidden>Transiting Planet</option>
                    <option
                        v-for="(singleTransitingPlanet, index) of ['', ...transiting_house_entry.transiting_planet]"
                        :key="index"
                        :value="singleTransitingPlanet"
                    >{{ singleTransitingPlanet }}
                    </option>
                  </select>
                </label>
              </div>

              <div class="col-4">
                <label for="transiting_house_entry">
                  <select
                      name="transiting_house_entry"
                      id="transiting_house_entry"
                      :disabled="isTransitionDataChecked || isHouseEntryChecked || isProgressedDataChecked || editMode"
                      v-model="transitingHouseEntryData.houseEntryValue"
                      :required="isTransitingHouseEntryChecked"
                  >
                    <option value="" disabled selected hidden>House entry</option>
                    <option
                        v-for="(singleHouseEntry, index) in ['', ...transiting_house_entry.house_entry]"
                        :key="index"
                        :value="singleHouseEntry"
                    >{{ singleHouseEntry }}
                    </option>
                  </select>
                </label>
              </div>

            </div>

            <div class="row title-row">

              <div class="col-12">
                <h2>Progressed House Entry</h2>
              </div>

              <div class="col-4">
                <label for="house_entry_planet">
                  <select
                      name="house_entry_planet"
                      id="house_entry_planet"
                      :disabled="isTransitionDataChecked || isProgressedDataChecked || isTransitingHouseEntryChecked || editMode"
                      v-model="houseEntryData.progressedPlanetValue"
                      :required="isHouseEntryChecked"
                  >
                    <option value="" disabled selected hidden>Progressed Planet</option>
                    <option
                        v-for="(single_transiting_planet, index) of ['', ...progressed_house_entry.progressed_planet]"
                        :key="index"
                        :value="single_transiting_planet"
                    >{{ single_transiting_planet }}
                    </option>
                  </select>
                </label>
              </div>

              <div class="col-4">
                <label for="house_entry">
                  <select
                      name="house_entry"
                      id="house_entry"
                      :disabled="isTransitionDataChecked || isProgressedDataChecked || isTransitingHouseEntryChecked || editMode"
                      v-model="houseEntryData.houseEntryValue"
                      :required="isHouseEntryChecked"
                  >
                    <option value="" disabled selected hidden>House Entry</option>
                    <option
                        v-for="(single_house_entry, index) of ['', ...progressed_house_entry.house_entry]"
                        :key="index"
                        :value="single_house_entry"
                    >{{ single_house_entry }}
                    </option>
                  </select>
                </label>
              </div>

              <div class="col-12">
                <h2>Interpretation</h2>
              </div>

              <div class="col-12">
                <label for="house_entry">
									<textarea
                      name="interpretation"
                      id="interpretation"
                      v-model="interpretation"
                  />
                </label>
              </div>
              <div class="col-12" v-if="errorMessage.length">
                <div class="errors-wrapper">
                  <div v-for="(singleError, index) in errorMessage" :key="index">{{
                      singleError
                    }}
                  </div>
                </div>
              </div>
              <div class="col-6">
                <button
                    v-if="editMode"
                    @click.prevent="deleteButtonHandler"
                >Delete
                </button>
              </div>
              <div class="col-6 buttons-wrapper align-end">
                <button
                    @click.prevent="handleRedirect"
                >Cancel
                </button>
                <input type="submit" value="Save">
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolFileAPIInstance from '@/api'

const mockInterpretation = {
  aspect: '',
  data: '',
  houseEntry: '',
  natalPlanet: '',
  progressedPlanet: '',
  transitingPlanet: ''
};

export default {
  props: {
    singleDiscovery: {
      required: false,
      type: Object
    },
    editMode: {
      required: false,
      type: Boolean
    }
  },
  name: "DiscoveryTableSingleComponents",
  data() {
    return {
      progressed: {},
      progressed_house_entry: {},
      transiting: {},
      transiting_house_entry: {},

      placeholders: {
        transitingPlanetPlaceholder: '',
      },
      transitionData: {
        transitingPlanetValue: '',
        aspectValue: '',
        natalPlanetValue: ''
      },
      progressedData: {
        progressedPlanetValue: '',
        aspectValue: '',
        natalPlanetValue: ''
      },
      transitingHouseEntryData: {
        transitingPlanetValue: '',
        houseEntryValue: ''
      },
      houseEntryData: {
        progressedPlanetValue: '',
        houseEntryValue: ''
      },
      interpretation: '',
      errorMessage: [],
    }
  },
  computed: {
    isTransitionDataChecked() {
      return Object.values(this.transitionData).some(Boolean)
    },
    isProgressedDataChecked() {
      return Object.values(this.progressedData).some(Boolean)
    },
    isHouseEntryChecked() {
      return Object.values(this.houseEntryData).some(Boolean)
    },
    isTransitingHouseEntryChecked() {
      return Object.values(this.transitingHouseEntryData).some(Boolean)
    }
  },
  watch: {

    isTransitionDataChecked(isChecked) {
      if (isChecked) {
        this.clearData('progressedData');
        this.clearData('houseEntryData');
        this.clearData('transitingHouseEntryData');
      }
    },

    isProgressedDataChecked(isChecked) {
      if (isChecked) {
        this.clearData('transitionData');
        this.clearData('houseEntryData');
        this.clearData('transitingHouseEntryData');
      }
    },

    isHouseEntryChecked(isChecked) {
      if (isChecked) {
        this.clearData('transitionData');
        this.clearData('progressedData');
        this.clearData('transitingHouseEntryData');
      }
    },

    isTransitingHouseEntryChecked(isChecked) {
      if (isChecked) {
        this.clearData('transitionData');
        this.clearData('progressedData');
        this.clearData('houseEntryData');
      }
    }

  },
  mounted() {
    this.fetchDropdownValues()
    if (this.editMode) {
      const {
        aspect,
        data,
        houseEntry,
        natalPlanet,
        progressedPlanet,
        transitingPlanet,
      } = this.singleDiscovery
      if (progressedPlanet && houseEntry) {
        this.houseEntryData = {
          progressedPlanetValue: progressedPlanet,
          houseEntryValue: houseEntry
        }
      }
      if (transitingPlanet && natalPlanet) {
        this.transitionData = {
          transitingPlanetValue: transitingPlanet,
          aspectValue: aspect,
          natalPlanetValue: natalPlanet
        }
      } else if (progressedPlanet && natalPlanet) {
        this.progressedData = {
          progressedPlanetValue: progressedPlanet,
          aspectValue: aspect,
          natalPlanetValue: natalPlanet
        }
      } else if (transitingPlanet && houseEntry) {
        this.transitingHouseEntryData = {
          transitingPlanetValue: transitingPlanet,
          houseEntryValue: houseEntry
        }
      }
      this.interpretation = data
    }
  },
  methods: {

    async fetchDropdownValues() {
      const response = await SolFileAPIInstance.getDiscoveryDropdownValues()
      const { data } = response
      this.progressed = data.progressed
      this.progressed_house_entry = data.progressed_house_entry
      this.transiting = data.transiting
      this.transiting_house_entry = data.transiting_house_entry
    },

    clearData(data) {
      Object.keys(this[data]).forEach(item => {
        this.$set(this[data], item, '');
      })
    },

    async deleteButtonHandler() {
      await SolFileAPIInstance.deleteDiscoveryInterpretationById(this.$route.params.id)
    },

    handleRedirect() {
      this.$router.push({path: '/discovery'})
    },

    formValidation() {
      this.errorMessage = [];
      const {
        isTransitionDataChecked,
        isProgressedDataChecked,
        isHouseEntryChecked,
        isTransitingHouseEntryChecked
      } = this
      if (!isHouseEntryChecked && !isTransitionDataChecked && !isProgressedDataChecked && !isTransitingHouseEntryChecked) {
        this.errorMessage.push('Please select at least one combination')
        return false
      }
      if (isTransitionDataChecked) {
        if (!Object.values(this.transitionData).every(Boolean)) {
          this.errorMessage.push('Please fill Transiting Planet fields')
          return false
        }
      }

      if (isProgressedDataChecked) {
        if (!Object.values(this.progressedData).every(Boolean)) {
          this.errorMessage.push('Please fill selected combination')
          return false
        }
      }

      if (isHouseEntryChecked) {
        if (!Object.values(this.houseEntryData).every(Boolean)) {
          this.errorMessage.push('Please fill selected combination')
          return false
        }
      }

      if (isTransitingHouseEntryChecked) {
        if (!Object.values(this.transitingHouseEntryData).every(Boolean)) {
          this.errorMessage.push('Please fill selected combination')
        }
      }

      if (!this.interpretation.trim()) {
        this.errorMessage.push('Please fill interpretation text')
        return false
      }

      return true
    },

    async handleFormSubmit() {
      if (this.formValidation()) {
        let infoAccumulator;
        const {
          isTransitionDataChecked,
          isProgressedDataChecked,
          isHouseEntryChecked,
          isTransitingHouseEntryChecked
        } = this
        if (isTransitionDataChecked) {
          infoAccumulator = this.transitionData
        } else if (isProgressedDataChecked) {
          infoAccumulator = this.progressedData
        } else if (isHouseEntryChecked) {
          infoAccumulator = this.houseEntryData
        } else if (isTransitingHouseEntryChecked) {
          infoAccumulator = this.transitingHouseEntryData
        }
        const transformedData = Object.entries(infoAccumulator).reduce((acc, item) => {
          const [label, value] = item
          acc[label.replace('Value', '')] = value
          return acc
        }, {})

        const dataToSend = {
          ...mockInterpretation,
          ...transformedData,
          data: this.interpretation
        }

        const response = this.editMode
            ? await SolFileAPIInstance.editDiscoveryInterpretationById(this.$route.params.id, dataToSend)
            : await SolFileAPIInstance.saveNewDiscoveryInterpretation(dataToSend)
        if (response && response.status && 200 === response.status)
          this.handleRedirect()
      }
    }

  }
}
</script>